'use client';

import BestBuySizingKitSection from './components/BestBuySizingKitSection';
import ConfirmSizeSection from './components/ConfirmSizeSection';
import Gen3SizeGuideModal from './components/Gen3SizeGuideModal';
import Gen3VideoModal from './components/Gen3VideoModal';
import Gen4SizeGuideModal from './components/Gen4SizeGuideModal';
import Gen4VideoModal from './components/Gen4VideoModal';
import InStoreSizingSection from './components/InStoreSizingSection';
import SizingGuidesSection from './components/SizingGuidesSection';
import SizingPageHero from './components/SizingPageHero';
import SizingPageRingModelsModal from './components/SizingPageRingModelsModal';
import SizingPageModalProvider from './contexts/SizingPageModalProvider';

const Content = (): JSX.Element => {
  return (
    <SizingPageModalProvider>
      <Gen4VideoModal />
      <Gen3VideoModal />
      <SizingPageRingModelsModal />
      <Gen4SizeGuideModal />
      <Gen3SizeGuideModal />
      <SizingPageHero />
      <ConfirmSizeSection />
      <SizingGuidesSection />
      <BestBuySizingKitSection />
      <InStoreSizingSection />
    </SizingPageModalProvider>
  );
};

export default Content;
